import React, { Component } from 'react';
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';

class DebitoCuenta extends Component {
    constructor(props) {
        super(props);

        this.state = { valor: "0" }
        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        const valor = event.target.value;
        const target = event.target;

        this.setState({ valor: valor }, () => {
            if (valor != "0") {
                const index = target.selectedIndex;
                const codigo = target.options[index].dataset.codigo;

                this.props.selectCombo(1, this.props.codigoNovedad, valor, codigo)
            }
        });
    }
    /**
     * 
     * @param {any} nextProps
     */
    componentWillReceiveProps(nextProps) {
        const { codigoNovedad, data, dataCompleto } = nextProps;
        let cuentasBancarias = [];
        let codigoSucursalCuenta = dataCompleto.CuentaBancariaSucursalCodigo;

        if (data.accountData.GET_CUENTAS_BANCARIAS) {
            cuentasBancarias = JSON.parse(JSON.stringify(data.accountData.GET_CUENTAS_BANCARIAS));
        }

        let cuentaBancariaNumeroId = "0";
        let cuentaBancariaNumeroValor = "";

        if (data.CuentaBancariaNumero) {
            cuentaBancariaNumeroId = data.CuentaBancariaNumero;
            cuentaBancariaNumeroValor = data.CuentaBancariaNumero;
        }

        if (dataCompleto.novedadesCuentaDatos) {
            const novedadCuentaBancaria = dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == codigoNovedad);

            const novedadSucursalCuenta = dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == "SUCUE_CUEN");

            //* Si tiene novedad propia.
            if (novedadCuentaBancaria) {
                const esNovedadEditadaDescripcion = dataCompleto.esNovedadEditada.find(x => x.campoCodigo == codigoNovedad).editado;

                if (esNovedadEditadaDescripcion == false) {
                    cuentaBancariaNumeroId = novedadCuentaBancaria.ValorNovedad;
                }
            }

            //* Si el combo de sucursal de la cuenta tiene una novedad, ésta repercute en el combo de este componente.
            if (novedadSucursalCuenta) {
                let idSucursalCuentaSelected = novedadSucursalCuenta.ValorNovedad;
                const sucursal = data.accountData.GET_ALL_SUCURSAL.find((suc) => suc.Id == idSucursalCuentaSelected);
                codigoSucursalCuenta = ((sucursal)? sucursal.Codigo : "")
            }
        }

        this.state.valor = cuentaBancariaNumeroId;
    }
    /**
     * 
     */
    render() {
        const { codigoNovedad, data, dataCompleto } = this.props;
        let cuentasBancarias = [];
        let codigoSucursalCuenta = dataCompleto.CuentaBancariaSucursalCodigo;

        if (data.accountData.GET_CUENTAS_BANCARIAS) {
            cuentasBancarias = JSON.parse(JSON.stringify(data.accountData.GET_CUENTAS_BANCARIAS));
            cuentasBancarias = cuentasBancarias.map(cb => cb.Cuenta);
        }

        let cuentaBancariaNumeroId = undefined
        let cuentaBancariaNumeroValor = undefined

        if (data.CuentaBancariaNumero) {
            cuentaBancariaNumeroId = data.CuentaBancariaNumero;
            cuentaBancariaNumeroValor = data.CuentaBancariaNumero;
        }

        //////////Novedad////////////
        let novedadCuentaBancaria = undefined;
        if (dataCompleto.novedadesCuentaDatos) {
            novedadCuentaBancaria = dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == codigoNovedad);
            const novedadSucursalCuenta = dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == "SUCUE_CUEN");

            if (novedadCuentaBancaria) {
                const cuentaBancariaAnterior = cuentasBancarias.find(x => x.Numero == novedadCuentaBancaria.ValorAnterior);
                const cuentaBancariaDescripcion = cuentasBancarias.find(x => x.Numero == novedadCuentaBancaria.ValorAnterior);
                const cuentaBancariaValor = cuentasBancarias.find(x => x.Numero == novedadCuentaBancaria.ValorNovedad);

                if (cuentaBancariaAnterior) {
                    novedadCuentaBancaria.ValorAnteriorFormateado = cuentaBancariaAnterior.Descripcion;
                } else {
                    novedadCuentaBancaria.ValorAnteriorFormateado = "";
                }

                let esNovedadEditadaDescripcion = dataCompleto.esNovedadEditada.find(x => x.campoCodigo == codigoNovedad).editado;

                if (esNovedadEditadaDescripcion == false) {
                    cuentaBancariaNumeroId = novedadCuentaBancaria.ValorNovedad;
                    cuentaBancariaNumeroValor = ((cuentaBancariaValor) ? cuentaBancariaValor.Numero : undefined);
                }
            }

            //* Si el combo de sucursal de la cuenta tiene una novedad, ésta repercute en el combo de este componente.
            if (novedadSucursalCuenta) {
                let idSucursalCuentaSelected = novedadSucursalCuenta.ValorNovedad;
                const sucursal = data.accountData.GET_ALL_SUCURSAL.find((suc) => suc.Id == idSucursalCuentaSelected);
                codigoSucursalCuenta = ((sucursal) ? sucursal.Codigo : "")
            }
        }
        ////////////////////////////////////////////////////
        cuentaBancariaNumeroValor = (cuentaBancariaNumeroValor ? cuentaBancariaNumeroValor : "Sin especificar");

        const componenteCuentaBancaria = (
            <select className="form-control default-select" value={cuentaBancariaNumeroId} onChange={this.selectCombo.bind(this)} >
                <option value="0">Seleccione...</option>
                {cuentasBancarias.filter((cue1) => cue1.Sucursal == codigoSucursalCuenta).map((cue2, index) => {
                    return (
                        <option value={cue2.Numero} key={"cuenta-numero-" + index} data-tipo={cue2.Tipo}>
                            {cue2.Numero}
                        </option>
                    );
                })}
            </select>
        );

        const error = ((this.state.valor == "0") || (cuentasBancarias.length == 0));

        if (novedadCuentaBancaria) {
            if (novedadCuentaBancaria.ValorAnterior == "") {
                novedadCuentaBancaria.ValorAnteriorFormateado = "Sin especificar";
            }
        }

        return (
            <GenericEditPanel
                componente={componenteCuentaBancaria}
                cuenta={data}
                error={error}
                novedad={novedadCuentaBancaria}
                permisoUsuario={dataCompleto.funcionesDelUsuario}
                seEstaEditando={dataCompleto.seEstaEditando}
                textPanel={cuentaBancariaNumeroValor || "Sin especificar"}
                title="Cuenta"
                value={cuentaBancariaNumeroValor}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadCuentaBancaria, 2, data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadCuentaBancaria, 3, data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar} />
        );
    }
}

export default DebitoCuenta;